import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error silently instead of crashing
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 32, textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>⚠</div>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: 'var(--color-label-primary)', marginBottom: 8 }}>
            Something went wrong
          </h2>
          <p style={{ fontSize: 14, color: 'var(--color-label-secondary)', marginBottom: 16 }}>
            This section encountered an error. Please try refreshing.
          </p>
          <button onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
            style={{ padding: '10px 24px', background: 'var(--color-accent)', color: 'white', border: 'none', borderRadius: 999, cursor: 'pointer', fontSize: 14, fontWeight: 500 }}>
            Refresh Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
